"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class EvaluatorTraining {
  static thaw(evaluatorTrainingObj) {
    if (evaluatorTrainingObj == null) return null;
    const evaluatorTraining = new EvaluatorTraining();
    if (evaluatorTrainingObj.id != null) evaluatorTraining.setId(evaluatorTrainingObj.id);
    if (evaluatorTrainingObj.status != null) evaluatorTraining.setStatus(evaluatorTrainingObj.status);
    if (evaluatorTrainingObj.completedTimestamp != null) evaluatorTraining.setCompletedTimestamp(_luxon.DateTime.fromISO(evaluatorTrainingObj.completedTimestamp));
    if (evaluatorTrainingObj.validTo != null) evaluatorTraining.setValidTo(_luxon.DateTime.fromISO(evaluatorTrainingObj.validTo));
    if (evaluatorTrainingObj.evaluatorId != null) evaluatorTraining.setEvaluatorId(evaluatorTrainingObj.evaluatorId);
    if (evaluatorTrainingObj.transactionId != null) evaluatorTraining.setTransactionId(evaluatorTrainingObj.transactionId);
    if (evaluatorTrainingObj.trainingModuleVersionId != null) evaluatorTraining.setTrainingModuleVersionId(evaluatorTrainingObj.trainingModuleVersionId);
    if (evaluatorTrainingObj.evaluator != null) evaluatorTraining.setEvaluator(_.Evaluator.thaw(evaluatorTrainingObj.evaluator));
    if (evaluatorTrainingObj.transaction != null) evaluatorTraining.setTransaction(_.Transaction.thaw(evaluatorTrainingObj.transaction));
    if (evaluatorTrainingObj.trainingModuleVersion != null) evaluatorTraining.setTrainingModuleVersion(_.TrainingModuleVersion.thaw(evaluatorTrainingObj.trainingModuleVersion));
    if (evaluatorTrainingObj.continuingEducationCreditsAwarded != null) evaluatorTraining.setContinuingEducationCreditsAwarded(evaluatorTrainingObj.continuingEducationCreditsAwarded);
    return evaluatorTraining;
  }

  static thawList(evaluatorTrainingObjList) {
    if (evaluatorTrainingObjList == null) return [];
    var evaluatorTrainings = [];

    for (var i = 0; i < evaluatorTrainingObjList.length; i++) {
      evaluatorTrainings.push(EvaluatorTraining.thaw(evaluatorTrainingObjList[i]));
    }

    return evaluatorTrainings;
  }

  static freeze(evaluatorTraining) {
    if (evaluatorTraining == null) return null;
    var evaluatorTrainingObj = {};
    if (evaluatorTraining.getId() != null) evaluatorTrainingObj.id = evaluatorTraining.getId();
    if (evaluatorTraining.getStatus() != null) evaluatorTrainingObj.status = evaluatorTraining.getStatus();
    if (evaluatorTraining.getCompletedTimestamp() != null) evaluatorTrainingObj.completedTimestamp = evaluatorTraining.getCompletedTimestamp();
    if (evaluatorTraining.getValidTo() != null) evaluatorTrainingObj.validTo = evaluatorTraining.getValidTo();
    if (evaluatorTraining.getEvaluatorId() != null) evaluatorTrainingObj.evaluatorId = evaluatorTraining.getEvaluatorId();
    if (evaluatorTraining.getTransactionId() != null) evaluatorTrainingObj.transactionId = evaluatorTraining.getTransactionId();
    if (evaluatorTraining.getTrainingModuleVersionId() != null) evaluatorTrainingObj.trainingModuleVersionId = evaluatorTraining.getTrainingModuleVersionId();
    if (evaluatorTraining.getEvaluator() != null) evaluatorTrainingObj.evaluator = _.Evaluator.freeze(evaluatorTraining.getEvaluator());
    if (evaluatorTraining.getTransaction() != null) evaluatorTrainingObj.transaction = _.Transaction.freeze(evaluatorTraining.getTransaction());
    if (evaluatorTraining.getTrainingModuleVersion() != null) evaluatorTrainingObj.trainingModuleVersion = _.TrainingModuleVersion.freeze(evaluatorTraining.getTrainingModuleVersion());
    if (evaluatorTraining.getContinuingEducationCreditsAwarded() != null) evaluatorTrainingObj.continuingEducationCreditsAwarded = evaluatorTrainingObj.getContinuingEducationCreditsAwarded();
    return evaluatorTrainingObj;
  }

  static freezeList(evaluatorTrainings) {
    if (evaluatorTrainings == null) return [];
    var evaluatorTrainingObjList = [];

    for (var i = 0; i < evaluatorTrainings.length; i++) {
      evaluatorTrainingObjList.push(EvaluatorTraining.freeze(evaluatorTrainings[i]));
    }

    return evaluatorTrainingObjList;
  }

  constructor() {
    this.setId(null);
    this.setStatus(null);
    this.setCompletedTimestamp(null);
    this.setValidTo(null);
    this.setEvaluatorId(null);
    this.setTransactionId(null);
    this.setTrainingModuleVersionId(null);
    this.setEvaluator(null);
    this.setTransaction(null);
    this.setTrainingModuleVersion(null);
    this.setContinuingEducationCreditsAwarded(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setStatus(status) {
    this.status = status;
  }

  setCompletedTimestamp(completedTimestamp) {
    this.completedTimestamp = completedTimestamp;
  }

  setValidTo(validTo) {
    this.validTo = validTo;
  }

  setEvaluatorId(evaluatorId) {
    this.evaluatorId = evaluatorId;
  }

  setTransactionId(transactionId) {
    this.transactionId = transactionId;
  }

  setTrainingModuleVersionId(trainingModuleVersionId) {
    this.trainingModuleVersionId = trainingModuleVersionId;
  }

  setEvaluator(evaluator) {
    this.evaluator = evaluator;
  }

  setTransaction(transaction) {
    this.transaction = transaction;
  }

  setTrainingModuleVersion(trainingModuleVersion) {
    this.trainingModuleVersion = trainingModuleVersion;
  }

  setContinuingEducationCreditsAwarded(continuingEducationCreditsAwarded) {
    this.continuingEducationCreditsAwarded = continuingEducationCreditsAwarded;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getStatus() {
    return this.status;
  }

  getCompletedTimestamp() {
    return this.completedTimestamp;
  }

  getValidTo() {
    return this.validTo;
  }

  getEvaluatorId() {
    return this.evaluatorId;
  }

  getTransactionId() {
    return this.transactionId;
  }

  getTrainingModuleVersionId() {
    return this.trainingModuleVersionId;
  }

  getEvaluator() {
    return this.evaluator;
  }

  getTransaction() {
    return this.transaction;
  }

  getTrainingModuleVersion() {
    return this.trainingModuleVersion;
  }

  getContinuingEducationCreditsAwarded() {
    return this.continuingEducationCreditsAwarded;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluatorTraining;